<template>
  <c360-edit-campaign-dialog
    :open="value"
    :token="token"
    :campaign-id="campaign.id"
    @closed="$emit('change', false)"
    @edit-campaign-errors="onError($event.detail)"
  />
</template>

<script>
  export default {
    name: 'EditCampaign',

    model: {
      prop: 'value',
      event: 'change'
    },

    props: {
      /**
       * AH compatible access-token.
       */
      token: {
        type: String,
        required: true,
      },

      /**
       * Campaign metadata to retrieve an actual campaign for editing.
       *
       * @type {{ id: string }}
       *
       * @example
       * ```vue
       * <c360-edit-campaign-dialog :campaign="{ id: "id" }" />
       * ```
       */
      campaign: {
        type: Object,
        required: true,
      },

      /**
       * v-model value of the dialog.
       */
      value: {
        type: Boolean,
        required: true,
      },
    },

    methods: {
      onError(errors) {
        this.$emit('edit-campaign-errors', errors);
      },
    },
  };
</script>
